import React from "react";
import { Heart, Repeat, Users, Package, Building2, Landmark, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/site/primitives";
import { WAYS_TO_GIVE } from "@/content/support";
import { scrollToId } from "@/lib/scrollTo";

const ICONS = {
  heart: Heart,
  repeat: Repeat,
  users: Users,
  package: Package,
  building: Building2,
  landmark: Landmark,
};

export const WaysToGive = () => {
  const handle = (way) => {
    if (way.action === "donate") {
      scrollToId("donate");
    } else {
      toast.success("Thanks for your interest!", {
        description: `We'll be in touch about ${way.title.toLowerCase()}. (Demo)`,
      });
    }
  };

  return (
    <section id="ways" aria-labelledby="ways-heading" className="wf-section bg-[var(--wf-cream)]">
      <div className="wf-container">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-green-text)]">Ways to give</span>
          <h2 id="ways-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">Find the way that fits you</h2>
          <p className="mt-3 text-base leading-7 text-muted-foreground">Whether it is time, money, or goods, there is a place for your generosity here.</p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WAYS_TO_GIVE.map((way, i) => {
            const Icon = ICONS[way.icon] || Heart;
            return (
              <Reveal key={way.id} delay={0.04 * (i % 3)}>
                <div className="group flex h-full flex-col rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] p-6 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-1.5">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm bg-[rgba(107,31,43,0.10)] text-[var(--wf-maroon)]">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                  </span>
                  <h3 className="mt-4 font-serif text-xl font-semibold text-[var(--wf-ink)]">{way.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-6 text-muted-foreground">{way.text}</p>
                  <button
                    type="button"
                    onClick={() => handle(way)}
                    data-testid={`way-cta-${way.id}`}
                    className="mt-5 inline-flex items-center gap-1.5 self-start rounded-full text-sm font-semibold text-[var(--wf-maroon)] transition-colors hover:text-[var(--wf-maroon-dark)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
                  >
                    {way.action === "donate" ? "Give now" : "Get in touch"}
                    <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
